import EventInfo from './EventInfo';

export default EventInfo;
